import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateField from './DateField';

export const isValidDateValue = value => moment(value, 'YYYY-MM-DD', true).isValid();

function PolishDateInput({ label, name, value, readOnly, error, onChange, onBlur }) {
  return (
    <div className="form-group">
      <span><strong>{label}</strong></span>
      <div className="input-group mt-1">
        <DateField
          name={name}
          aria-label={label}
          placeholder="DD.MM.RRRR"
          className={`form-control${error ? ' is-invalid' : ''}`}
          value={value}
          readOnly={readOnly}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete="off"
        />
        <div className="invalid-feedback">{error}</div>
      </div>
    </div>
  );
}

PolishDateInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};
PolishDateInput.defaultProps = { value: '', readOnly: false, error: undefined };

export default PolishDateInput;
